'use client';

import React from 'react';
import Image from 'next/image';
import { formatHighlightedText, resolveImageAltText } from '@/lib/utils';

export default function FillerCard({
  cardData,
  index: cardIndex,
  collectionPage
}) {
  const { card_type, expanded_card } = cardData ?? {};
  const fillerCardData = card_type?.[0]?.filler;

  return (
    <div
      id={`product-group-card-${cardData?.uid}`}
      className={`border-dawn-grey-30 border bg-white ${expanded_card ? 'lg:col-span-3' : 'col-span-1'} relative overflow-hidden`}
      data-optimizely="filler-group-card"
    >
      {/* Background Image that fills the card */}
      {fillerCardData?.card_background_image?.url && (
        <div className="absolute inset-0">
          <Image
            src={fillerCardData?.card_background_image?.url}
            alt={resolveImageAltText(fillerCardData?.card_background_image)}
            fill
            priority={cardIndex <= 2 && collectionPage}
            className="object-fill"
          />
        </div>
      )}
      {/* Light text optional text content with optional secondary colored text */}
      <div className="relative z-10 flex h-full min-h-[449px] max-w-full flex-col justify-between">
        <div
          className={`flex flex-col px-10 ${expanded_card ? 'lg:h-full lg:justify-center lg:px-10' : 'pt-20'}`}
        >
          <div
            className={`h3 ${fillerCardData?.light_text ? 'text-white' : 'text-black'}`}
          >
            {formatHighlightedText(fillerCardData?.heading_rte, {
              color: fillerCardData?.secondary_text_color
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
